<template>
    <div class="col" :class="[ containerClass]">
        <div class="row" :class="[containerClass]" v-if="normal">
            <div class="col-3" v-if="showPlaceholder">
            <label :for="elementID" class="input-label" :class="{required: required}">
                {{placeholder}}
            </label>
            </div>
            <div :class="{'col-9': showPlaceholder}">
            <div class="input-group">
                <input :type="inputType"
                        :id="elementID"
                        :placeholder="placeholder"
                        :class="[validatorClass, 'form-control', inputClass]"
                        :value="value"
                        :disabled="disabled"
                        :required="required"
                        @input="validator ? validator.$touch() : null; updateValue($event.target.value)"
                        @blur="$emit('blur', blurValue($event.target.value))"
                        :min="min"
                        :max="max"
                        step="any"
                        @keydown.enter="$emit('enterPressed')">
                <div class="input-group-append" v-if="showRemove">
                    <span class="input-group-text bg-danger text-white py-0"
                            @click="$emit('remove')">
                        X
                    </span>
                </div>
            </div>
            </div>
        </div>
    <div class="input-group" v-else>
        <input :type="inputType"
                :id="elementID"
                :placeholder="placeholder"
                :class="[validatorClass, 'form-control', inputClass]"
                :value="value"
                :disabled="disabled"
                :required="required"
                :min="min"
                :max="max"
                step="any"
                @blur="$emit('blur', blurValue($event.target.value))"
                @input="validator ? validator.$touch() : null; updateValue($event.target.value)"
                @keydown.enter="$emit('enterPressed')">
        <div class="input-group-append" v-if="showRemove">
            <span class="input-group-text bg-danger text-white py-0"
                @click="$emit('remove')">
                X
            </span>
        </div>
    </div>
    </div>
</template>

<script type="text/babel">
import CphButton from '../Button/CphButton.vue';
import xss from  'xss';
import toNumber from 'lodash.tonumber';
export default {
    name: 'FormInput',
    props: {
        required: {
          type: Boolean,
          default: false
        },
        normal:{
            type: Boolean,
            default: true
        },
        value: {
            type: [String, Number, Boolean]
        },
        validator: {
            type: Object
        },
        showPlaceholder: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String
        },
        inputType: {
            type: String,
            default: 'text'
        },
        elementID: {
            type: String
        },
        containerClass: {
            type: String,
            default: 'col-12 col-md-6 mt-2'
        },
        inputClass: {
            type: String,
            default: ''
        },
        displayLabel: {
            type: Boolean,
            default: true
        },
        showRemove: {
            type: Boolean,
            default: false
        },
        focus: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        min: {
            default: undefined
        },
        max: {
            default: undefined
        },
    },
    components: {
        CphButton
    },
    computed: {
        validatorClass () {
            if(!this.validator) {
                return {};
            }
            return {
                'invalid': this.validator.$invalid,
                'dirty': this.validator.$dirty,
                'valid': !this.validator.$invalid
            };
        }
    },
    methods: {
        updateValue (value) {
            let newVal = this.inputType === 'number' ? toNumber(value) : xss(value);
            this.$emit('input', newVal);
        },
        blurValue (value) {
            let newVal = this.inputType === 'number' ? toNumber(value) : xss(value);
            this.$emit('blur', newVal);
        },
        showField () {
            return this.validator.$invalid && this.validator.$dirty;
        }
    },
    mounted () {
        if(this.focus) {
            this.$nextTick(() => {
                let input = document.getElementById(this.elementID);
                if(input) {
                    input.focus();
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
  label{
    float: right;
    margin-bottom: 0;
    line-height: 2em;
    &.required{
      &:after { content: '*';color:red; }
    }
  }
  .form-group{
      .form-control-sm{
        font-size: 13px;
      }
    &.row{
      padding: 3px 0;
    }
    margin-bottom: 5px;
  }
  .form-control:focus{
    outline: 0;
    border: 1px solid #8ca3f1;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  input {
      &.invalid.dirty {
          border-color: red;
      }
  }
  input::-webkit-input-placeholder {
        color: lightgray;            
}
</style>
